// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetResponsibleManagers-moduleitemsListTitleWrapper__kTs4r WidgetContentItemsList-moduletitleWrapper__Wdg5G";
var _2 = "RequestProfileWidgetResponsibleManagers-modulemanagersContent__LFB2X WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
export { _1 as "itemsListTitleWrapper", _2 as "managersContent" }
